module.exports = require('./PlaceholderView');
